module.exports = require('./PlaceholderView');
